module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-shadow-2.db03a64e.png";